import React from "react";
import { HiArrowRight } from "react-icons/hi2";
import { twMerge } from "tailwind-merge";
import { CTA } from "../../types/blocks";
import Link from "../atoms/link";

export interface CTAsProps {
  ctas: CTA[];
  className?: string;
}

const CTAs = ({ ctas, className }: CTAsProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4",
        className
      )}
    >
      {ctas[0] && (
        <Link to={ctas[0].target} variant="primary" size="lg">
          {ctas[0].text}
          <HiArrowRight className="w-5 h-5 ml-2" />
        </Link>
      )}
      {ctas[1] && (
        <Link
          to={ctas[1].target}
          size="lg"
          className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-secondary-900 border border-gray-300 rounded-lg hover:bg-secondary-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-secondary-700 dark:focus:ring-gray-800"
        >
          {ctas[1].text}
        </Link>
      )}
    </div>
  );
};

export default CTAs;
